import Papa from 'papaparse';

export const prependFilterSectionToCsv = (
    bodyCsv: string,
    filterRows: string[][],
    delimiter: string,
): string => {
    if (!filterRows.length) {
        return bodyCsv;
    }
    const filtersCsv = Papa.unparse(filterRows, { delimiter });
    return `${filtersCsv}\n\n${bodyCsv}`;
};
